export const alertType = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
};

export const alertText = {
  UPD_PHOTO_SUCCES: 'Photo updated!',
  UPD_PHOTO_FAIL: 'Photo has not been updated!',
  DP_WAS_CREATED: 'DP successfully created',
  DP_WAS_UPDATED: 'DP was successfully updated',
  DP_WASNT_CREATED: 'DP was not created',
  DP_WASNT_UPDATED: 'DP was not updated',
  DP_WAS_DELETED: 'DP successfully deleted',
  DP_WAS_ARCHIVED: 'Group has been successfully archived',
  DP_WAS_UNARCHIVED: 'Group has been successfully unarchived',
  ADMIN_GRANTED: 'Admin access granted',
  ADMIN_REMOVED: 'Admin access removed',
  LEADER_EXCLUDED: 'Leader successfully excluded from DP',
  LEADER_WASNT_EXCLUDED: 'Leader was not excluded',
  LEADER_WAS_ADDED: 'Leader successfully added',
  LEADER_WASNT_ADDED: 'Leader not added',
  LEADER_STATUS_REMOVED: 'Leader status removed',
  LEADER_STATUS_ADDED: 'Leader status setted',
  MEMBER_EXCLUDED: 'Member successfully excluded from DP',
  MEMBER_WASNT_EXCLUDED: 'Member was not excluded',
  MEMBER_WAS_ADDED: 'Member successfully added',
  MEMBER_WAS_REMOVED: 'Member has been successfully removed',
  MEMBER_WASNT_ADDED: 'Member was not added',
  HOMEFEED_MSG_WASNT_SENT: 'Homefeed message was not sent',
  UPD_EVENT_SUCCESS: 'Event successfully updated',
  UPD_EVENT_FAIL: 'Event was not update',
  EVENT_WAS_CREATED: 'Event was created',
  EVENT_WASNT_CREATED: 'Event was not created',
  EVENT_WASNT_DELETED: 'Event was not deleted',
  EVENT_WAS_DELETED: 'Event successfully deleted',
  SERVICE_WAS_CREATED: 'Service successfully created!',
  SERVICE_WASNT_CREATED: 'Service was not created!',
  SERVICE_WAS_DELETED: 'Service successfully deleted!',
  SERVICE_WASNT_DELETED: 'Service was not deleted',
  PROFILE_WAS_UPDATED: 'Profile successfully updated',
  PROFILE_WASNT_UPDATED: 'Profile has not been updated',
  PROFILE_PHOTO_WAS_UPDATED: 'Profile photo successfully updated!',
  PROFILE_PHOTO_WASNT_UPDATED: 'Profile photo has not been updated!',
  FIRST_NAME_IS_EMPTY: 'First name field is empty',
  LAST_NAME_IS_EMPTY: 'Last Name field is empty',
  EMAIL_IS_EMPTY: 'Email field is empty',
  PASSWORD_IS_EMPTY: 'Password field is empty',
  INVALID_TOKEN: 'Token is not valid',
  RESET_LETTER_WAS_SENT: 'The letter has been sent. Please check your email!',
  PASSWORD_WAS_UPDATED: 'Password was updated',
  PASSWORD_WASNT_UPDATED: 'Password was not updated',
  USER_EMAIL_FAIL: 'User with this email already exists',
  ATTENDANCE_SUCCESS: 'Attendance created successfully,',
  LOCATION_IS_EMPTY: 'Location not selected',
  CADANCE_CREATED: 'Cadence has been successfully created',
  CADANCE_UPDATED: 'Cadence has been successfully updated',
  CADANCE_NOT_CREATED: 'Cadence has not been created',
  CADANCE_NOT_UPDATED: 'Cadence has not been updated',
  SERVICE_SLOT_NOT_DELETED: 'Service Slot was not deleted',
  VIDEO_SUCCESS_CREATE: 'Video successfully created',
  HOMEFEED_DELETED: 'Homefeed successfully deleted',
  CREATE_NEW_POST: `New post was created!`,
  FORM_COMPLETE_NEEDED: `You should complete the form.`,
  UPDATE_LATEST_MESSAGE: 'Latest message was successfully updated',
  DEVOTIONAL_CREATED: 'Devotion successfully created',
  DEVOTIONAL_UPDATED: 'Devotion successfully updated',
  DEVOTIONAL_DELETED: `Devotional successfully deleted`,
  DEVOTIONAL_NOT_DELETED: `Devotional was not deleted`,
  CALL_TO_ACTIONS_CREATED: 'Call to Actions successfully created',
  CALL_TO_ACTIONS_UPDATE: 'Call to Actions successfully updated',
  CALL_TO_ACTIONS_DELETE: `Call to Action successfully deleted`,
  PROFILE_EDITED: 'Profile has been edited successfully',
  WELCOME_PAGE_EDITED: 'Welcome page updated!',
  APPROVE_REQUEST: 'Request approved',
  DECLINE_REQUEST: 'Request declined',
  ERROR: 'Error',
  REQUEST_FAIL: 'Something went wrong',
  BIRTHDAY_IS_EMPTY: 'Birthday field is empty',
  COUNTRY_IS_EMPTY: 'Please select a country',
  BIRTHDAY_IS_INVALID: 'Please enter valid birthday date',
  MEMBER_ARCHIVED: 'Member is archived successfully',
  MEMBER_UNARCHIVED: 'Member is unarchived successfully',
};
